// Frame 21 — checkout return: cancelled (33:4061). US-142.
//
// This frame reads cleanly against the payment-provider-excluded build,
// unlike frame 20: "Nothing was charged" is true regardless of whether a
// checkout ever ran, and the trial-countdown copy is exactly what
// GET /licenses already carries (days_remaining / expires_at / domains[0]).
//
// One deliberate change from the drawn copy: the second button was labelled
// "TRY AGAIN", implying a checkout retry flow that does not exist in this
// run. Both actions route back to /billing — there is no separate checkout
// entry point to relaunch — worded so neither promises what it can't do.

import { Button } from "../../ui/Button";
import { useLicense } from "./api";
import { hrefs } from "../../shell/hrefs";
import { formatDate } from "./format";
import { CheckoutReturnPanel } from "./CheckoutReturnPanel";
import "./commerce.css";

export function CheckoutCancelledScreen({ orgSlug }: { orgSlug: string }) {
  const license = useLicense();
  const to = hrefs(orgSlug);

  const body = describeCancellation(license.data, license.isPending);

  return (
    <CheckoutReturnPanel
      icon="info"
      iconTone="neutral"
      title="Checkout cancelled"
      body={body}
      actions={
        <>
          <Button to={to.billing} variant="secondary">
            Back to billing
          </Button>
          <Button to={to.billing} variant="primary">
            View plans
          </Button>
        </>
      }
    />
  );
}

function describeCancellation(
  license: ReturnType<typeof useLicense>["data"],
  isPending: boolean,
): string {
  if (isPending) return "Nothing was charged.";
  if (!license || license.resolved_state === "unknown") {
    return "Nothing was charged. Your plan is unchanged.";
  }
  if (license.resolved_state === "trial") {
    const until = formatDate(license.expires_at);
    const domain = license.domains[0];
    if (until && domain) {
      return `Nothing was charged. Your trial keeps running until ${until} — the widget stays live on ${domain} until then.`;
    }
    if (until) {
      return `Nothing was charged. Your trial keeps running until ${until}.`;
    }
  }
  return "Nothing was charged. Your plan is unchanged.";
}
